import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { UserListResponse, UserModel } from './user.model';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private http: HttpClient,
    private toastr: ToastrService,
    @Inject('API_URL') private apiUrl: string
  ) { }

  private userComponentMethodCaller = new Subject<any>();
  componentMethodCalled$ = this.userComponentMethodCaller.asObservable();

  callAddOrEditUserOpenDialog() {
    this.userComponentMethodCaller.next();
  }

  getUsers(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<UserListResponse> {
    return this.http
      .get<UserListResponse>(
        this.apiUrl + 'user/users',
        {
          params: new HttpParams()
            .set('sortBy', sortBy)
            .set('sortDir', sortDir)
            .set('pageNumber', pageIndex.toString())
            .set('pageSize', pageSize.toString())
            .set('filter', JSON.stringify(filter))
        }
      );
  }

  saveUser(userModel: UserModel): Observable<UserModel> {
    return this.http
      .post<any>(this.apiUrl + 'user/save', userModel)
      .pipe(map(response => {
        if (response.error.message) {
          this.toastr.error(response.error.message);          
        }
        return response.model;
      })
    );
  }
}
